<script setup lang="ts"></script>

<template>
  <div
    class="bg-base-300 container mx-auto flex h-screen flex-col overflow-y-auto px-8 py-4 text-center"
  >
    <div class="mx-auto mt-[20vh] mb-4 flex items-center gap-12">
      <div>
        <h1 class="text-2xl">Ối! Không tìm thấy trang</h1>
        <p class="text-base-content/80">
          Trang web bạn tìm kiếm không khả dụng.
        </p>
      </div>
    </div>
    <router-link to="/">
      <i class="fa-solid fa-house mr-2"></i>
      <span class="link font-bold">Về trang chủ</span>
    </router-link>
  </div>
</template>
